module.exports = __webpack_public_path__ + "static/img/about_us_en.8f68891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_10_23/about_us_en.png
// module id = eHpO
// module chunks = 1